import type { FC } from 'react';
import { Avatar } from 'antd';
import type { AvatarProps } from 'antd';
import { TbBuilding } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import type { MetricChartCompany } from '@/shared/components/data-visualization/recharts';
import { corporateLogo } from '@/utilities';

interface FinancialCompanyAvatarProps extends Omit<AvatarProps, 'icon' | 'src'> {
    company: MetricChartCompany;
}

const FinancialCompanyAvatar: FC<FinancialCompanyAvatarProps> = ({ company, shape = 'square', style, ...props }) => {
    const { token } = useAntDesignTheme();
    const logo = company.website ? corporateLogo(company.website) : undefined;

    return (
        <Avatar
            {...props}
            icon={<TbBuilding />}
            shape={shape}
            src={logo}
            style={{
                background: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                flex: 'none',
                ...style,
            }}
        />
    );
};

export default FinancialCompanyAvatar;
